import { render, staticRenderFns } from "./SidebarOpener.vue?vue&type=template&id=0b9d51a4&scoped=true&"
import script from "./SidebarOpener.vue?vue&type=script&lang=js&"
export * from "./SidebarOpener.vue?vue&type=script&lang=js&"
import style0 from "./SidebarOpener.vue?vue&type=style&index=0&id=0b9d51a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d51a4",
  null
  
)

export default component.exports